module.exports = __webpack_public_path__ + "img/Box.f0e0f89a.png";